<app-application-container>
  <div class="bt-5 pt-5">
    <div class="my-5 h2 d-flex justify-content-center">
      You are not authorized to access this module.
    </div>
    <div class="my-5 h2 d-flex justify-content-center">
      Please contact IT for further information.
    </div>
    <div class="my-5 h1 d-flex justify-content-center text-warning">
      <i class="fa-solid fa-shield-exclamation fa-beat-fade fa-3x"></i>
    </div>


  </div>

</app-application-container>



// WEBPACK FOOTER //
// ./src/app/core/components/unauthorized/unauthorized.component.html